import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { content } from '../data/content';
import { ServiceAreaMap } from './ServiceAreaMap';
export function ServiceAreas() {
  return <section className="py-20 bg-brand-cream border-y border-brand-tan/20" data-id="element-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-202">
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-203">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-display text-3xl md:text-4xl font-bold text-brand-brown mb-6" data-id="element-204">
              {content.serviceAreas.heading}
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-lg text-brand-brown/80 mb-8" data-id="element-205">
              {content.serviceAreas.body}
            </motion.p>

            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex flex-wrap justify-center lg:justify-start gap-3" data-id="element-206">
              {content.serviceAreas.areas.map((area, index) => <span key={index} className="inline-flex items-center px-4 py-2 rounded-full bg-white border border-brand-tan/30 text-brand-brown font-medium text-sm shadow-sm hover:border-brand-orange hover:text-brand-orange transition-colors" data-id="element-207">
                  <MapPin className="w-4 h-4 mr-1.5 text-brand-amber" data-id="element-208" />
                  {area}
                </span>)}
            </motion.div>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-209">
            {/* Real interactive East Valley map */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="relative w-full aspect-video md:aspect-[4/3] rounded-2xl overflow-hidden border border-brand-tan/30 shadow-lg" data-id="element-210">
              <ServiceAreaMap data-id="element-211" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}